import React, { useState } from "react";
import { KanbanSquare, Inbox, Zap, Mail, Server } from "lucide-react";
import Pipeline from "../../pages/Pipeline";
import Marketing from "../../pages/Marketing";
import Automations from "../../pages/Automations";
import EmailSettingsCard from "../EmailSettingsCard";

const SUBTABS = [
  ["pipeline", "Pipeline", KanbanSquare],
  ["leads", "Leads", Inbox],
  ["automations", "Automations", Zap],
  ["email", "Email Builder", Mail],
  ["smtp", "SMTP", Server],
];

const HELP = {
  pipeline: "Track every prospect from New Lead → Contacted → Demo → Trialing → Won. Demo requests, trial signups & website leads land here automatically.",
  leads: "Build lead-capture forms and review incoming submissions from your marketing site.",
  automations: "Nurture prospects automatically — send emails, SMS, tasks & reminders when a lead enters a stage.",
  email: "Design and send email campaigns to your prospect list with the drag-and-drop builder.",
  smtp: "Connect the outbound mail server used to send platform sales emails, campaigns & automations.",
};

export default function PlatformCRM() {
  const [sub, setSub] = useState("pipeline");

  return (
    <div data-testid="platform-crm">
      {/* Sub-tab bar (dark, matches console chrome) */}
      <div className="flex items-center gap-2 mb-4 flex-wrap">
        <div className="inline-flex rounded-lg bg-white/5 p-1 border border-white/10" data-testid="platform-crm-subtabs">
          {SUBTABS.map(([key, label, Icon]) => (
            <button
              key={key}
              data-testid={`platform-crm-subtab-${key}`}
              onClick={() => setSub(key)}
              className={`inline-flex items-center gap-1.5 px-3 h-8 rounded-md text-[12.5px] font-medium transition-colors ${
                sub === key ? "bg-cyan-500/20 text-cyan-300" : "text-slate-400 hover:text-slate-200 hover:bg-white/5"
              }`}
            >
              <Icon className="h-3.5 w-3.5" /> {label}
            </button>
          ))}
        </div>
      </div>

      <p className="text-[12.5px] text-slate-500 mb-3">{HELP[sub]}</p>

      {/* Dark canvas — reuse the app's "Command Center" dark skin so the embedded
          tenant engines match the rest of the Platform Console. */}
      <div className="cc-theme dark bg-[#0A0F1C] rounded-2xl border border-white/10 overflow-hidden min-h-[60vh]" data-testid="platform-crm-canvas">
        {sub === "pipeline" && <Pipeline embedded />}
        {sub === "leads" && (
          <div className="p-4 sm:p-6">
            <Marketing embedded initialTab="leads" restrictTabs={["forms", "leads"]} />
          </div>
        )}
        {sub === "automations" && <Automations embedded />}
        {sub === "email" && (
          <div className="p-4 sm:p-6">
            <Marketing embedded initialTab="campaigns" restrictTabs={["campaigns"]} />
          </div>
        )}
        {sub === "smtp" && (
          <div className="p-4 sm:p-6 max-w-3xl">
            <EmailSettingsCard />
          </div>
        )}
      </div>
    </div>
  );
}
